import React from 'react';
import { roleColorIndex, roleInitials } from 'shared/src/utils/user/user-utils';

type BadgeTheme = 'light' | 'dark';

const PALETTES: Record<BadgeTheme, { roles: string[]; overflow: string }> = {
  light: {
    roles: [
      'bg-sky-100 text-sky-700',
      'bg-emerald-100 text-emerald-700',
      'bg-amber-100 text-amber-700',
      'bg-violet-100 text-violet-700',
      'bg-rose-100 text-rose-700',
      'bg-cyan-100 text-cyan-700',
      'bg-lime-100 text-lime-700'
    ],
    overflow: 'bg-slate-200 text-slate-600'
  },
  dark: {
    roles: [
      'bg-sky-500/20 text-sky-300',
      'bg-emerald-500/20 text-emerald-300',
      'bg-amber-500/20 text-amber-300',
      'bg-violet-500/20 text-violet-300',
      'bg-rose-500/20 text-rose-300',
      'bg-cyan-500/20 text-cyan-300',
      'bg-lime-500/20 text-lime-300'
    ],
    overflow: 'bg-slate-700 text-slate-300'
  }
};

const BADGE_BASE =
  'inline-flex items-center rounded px-1 py-0.5 text-[10px] font-semibold leading-none';

/** First two role acronyms plus a +N overflow chip; full names live in the title tooltips. */
export function UserRoleBadges({ roles, theme }: { roles: string[]; theme: BadgeTheme }) {
  const palette = PALETTES[theme];
  if (roles.length === 0) return null;
  return (
    <span className="flex shrink-0 items-center gap-1">
      {roles.slice(0, 2).map(role => (
        <span
          key={role}
          title={role}
          className={`${BADGE_BASE} ${palette.roles[roleColorIndex(role, palette.roles.length)]}`}>
          {roleInitials(role)}
        </span>
      ))}
      {roles.length > 2 ? (
        <span title={roles.join(', ')} className={`${BADGE_BASE} ${palette.overflow}`}>
          +{roles.length - 2}
        </span>
      ) : null}
    </span>
  );
}
